import request from "@/utils/request"

export default function agentGetMonthlyReport(params) {
    return request({
        url: `/fund/order/agentGetMonthlyReport`,
        params: params
    })
}












